module.exports = __webpack_public_path__ + "static/media/2.8f35b710.svg";